import keys from '@debbie/common/dist/cache/keys.js';
import { Site } from '@debbie/common/dist/index.js';
import { UpdateType, } from '@debbie/common/dist/updates/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as connect from '@debbie/cortex/dist/api/connect.js';
import * as updatesLib from '@debbie/cortex/dist/api/updates.js';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors.js';
import { SITE } from '@debbie/cortex/dist/config.js';
import { useConnectCaseMapping } from '@debbie/cortex/dist/connect/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { ensureUpdatesLoadedByRef, updatesEntity, } from '@debbie/cortex/dist/updates/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import { Clock } from '../Icons/index.js';
import Play from '../Icons/Play.js';
import X from '../Icons/X.js';
import { Button, ButtonGroup, DateInput, Modal } from '../index.js';
import TaskButtons from './TaskButtons.js';
const CasePauseActions = (props) => {
    const lang = useSelector((s) => s.lang);
    const [patchUpdateOpen, setPatchModalOpen] = useState(false);
    const [remindedAt, setRemindedAt] = useState(props.update.remindedAt ? moment(props.update.remindedAt) : null);
    const { singleCase, futurePause, update, updateType, canContinueCase, stack, isAwaitingClient, nextTask, } = props;
    const continueButton = futurePause || !updateType.pausing;
    const continueCaseMutation = useMutation(async (updateId) => {
        await updatesLib.patch(updateId);
        q.invalidate(keys.write.modify(updatesEntity, updateId));
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.update);
        },
    });
    const authToken = useSelector(selectAuthToken);
    const creditorLinkMutation = useMutation(async (mappingId) => {
        const res = await connect.getMappingCreditorLink(mappingId);
        window.location.href = res.link + `&authToken=${authToken}`;
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'any', lang.errorEntities.creditorLink);
        },
    });
    const saveRemindedAtMutation = useMutation(async (date) => {
        for (const stackItem of stack) {
            await updatesLib.patch(stackItem.update.updateId, {
                remindedAt: date?.toISOString(),
            });
        }
        q.invalidate(keys.write.modify(updatesEntity, ''));
        await ensureUpdatesLoadedByRef(singleCase.caseId);
        setPatchModalOpen(false);
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.remindDate);
        },
    });
    if (update.updateTypeId === UpdateType.SentToConnectPartner &&
        update.data != null &&
        update.data.mappingId != null) {
        const mappingId = update.data.mappingId;
        const mapping = useConnectCaseMapping(mappingId);
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { blockOnMobile: true, theme: "light", disabled: h.isError(mapping), onClick: () => {
                    if (h.hasData(mapping)) {
                        c.redirect.redirect(`/settings/connect/connections/${mapping.data.connectConnectionId}`);
                    }
                } }, lang.connect.goToConnection),
            React.createElement(Button, { blockOnMobile: true, onClick: () => {
                    creditorLinkMutation.mutate(mappingId);
                }, loading: creditorLinkMutation.isLoading }, lang.connect.goToCreditorWeb)));
    }
    return (React.createElement(React.Fragment, null,
        nextTask &&
            // @ts-ignore
            nextTask.manual &&
            // @ts-ignore
            nextTask.tasks &&
            nextTask.pastUpdate?.updateId === update.updateId &&
            // @ts-ignore
            !!nextTask.tasks.length ? (React.createElement(TaskButtons, { tasks: nextTask.tasks, case: singleCase })) : canContinueCase ? (React.createElement(ButtonGroup, null,
            React.createElement(Button, { blockOnMobile: true, theme: "light", size: "small", onClick: () => {
                    setPatchModalOpen(!patchUpdateOpen);
                } },
                React.createElement(Clock, { style: { margin: '.1em 0 -.2em' } })),
            React.createElement(Button, { blockOnMobile: true, loading: continueCaseMutation.isLoading, theme: continueButton ? 'light' : 'warning', size: "small", onClick: () => {
                    stack.forEach((stackItem) => {
                        continueCaseMutation.mutate(stackItem.update.updateId);
                        props.setDeletingUpdate(stackItem.update.updateId, true);
                    });
                } },
                continueButton ? (React.createElement(X, { style: { margin: '.1em 0 -.2em' } })) : (React.createElement(Play, { style: { margin: '0.1em 0 -.2em' } })),
                ' ',
                continueButton
                    ? lang.updates.continueCaseRemove
                    : lang.updates.continueCase))) : ((Site.Caseworker === SITE ||
            (isAwaitingClient && Site.Client == SITE)) && (React.createElement(X, { style: {
                margin: '0.55em 0',
                cursor: 'pointer',
            }, onClick: () => {
                continueCaseMutation.mutate(update.updateId);
                props.setDeletingUpdate(update.updateId, true);
            } }))),
        patchUpdateOpen && (React.createElement("div", { style: { color: 'initial' } },
            React.createElement(Modal, { header: lang.updates.setRemindedAt, onToggle: () => setPatchModalOpen(!patchUpdateOpen), maxWidth: "300px" },
                React.createElement(DateInput, { placeholder: lang.updates.remindDate, onChange: (d) => {
                        setRemindedAt(d);
                        if (d) {
                            saveRemindedAtMutation.mutate(d);
                        }
                    }, value: remindedAt, allowNull: true }),
                React.createElement(Button, { block: true, loading: saveRemindedAtMutation.isLoading, disabled: !remindedAt, onClick: () => {
                        if (remindedAt) {
                            saveRemindedAtMutation.mutate(remindedAt);
                        }
                    } },
                    lang.updates.remindDate,
                    ' ',
                    remindedAt?.format(THEME.DATE_FORMAT_SHORT)))))));
};
export default CasePauseActions;
//# sourceMappingURL=CasePauseActions.js.map